export async function loadLinksPlugin(engine, refresh = true) {
    const { LinksPlugin } = await import("./LinksPlugin.js"), plugin = new LinksPlugin();
    await engine.addPlugin(plugin, refresh);
}
